import styled from 'styled-components';
import { H1 } from '../../style/typography';
import { min } from '../../lib/responsive';
import { HorizontalRedLines } from '../../lib/shared';

const GetInvolvedHeader = styled(H1)`
  margin-bottom: -1.2em;
  transform: rotate(-3.38deg);
  font-size: clamp(3em, 16vw, 5em);
  @media ${min.tabletSm} {
    font-size: clamp(5em, 16vw, 15em);
  }
`;

const GetInvolvedHeaderContainer = styled.div`
  padding-bottom: 20rem;
  padding-top: 4rem;
  @media ${min.tabletSm} {
    padding-left: 1rem;
  }
  @media ${min.tablet} {
    padding-bottom: 28rem;
  }
  @media ${min.tabletLg} {
    padding-top: 3rem;
  }
  @media ${min.desktop} {
    padding-left: 3rem;
    padding-top: 0;
  }
`;

const RedMicImage = styled.img`
  position: absolute;
  right: -6rem;
  width: 80%;
  z-index: -1;
  top: 5rem;
  max-width: 50rem;
  @media ${min.tabletSm} {
    z-index: 2;
    right: 0;
    top: 5.5rem;
    width: 55%;
  }
  @media ${min.tablet} {
    top: 5.8rem;
  }
  @media ${min.desktop} {
    top: 3.8rem;
  }
`;

const GetInvolvedContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const GetInvolvedHorizontalRedLines = styled(HorizontalRedLines)`
  top: 15rem;
  @media ${min.tablet} {
    top: 19rem;
  }
`;

export {
  GetInvolvedHeader,
  GetInvolvedHeaderContainer,
  RedMicImage,
  GetInvolvedContainer,
  GetInvolvedHorizontalRedLines,
};
